import gql from "../gql";
export default gql `
  fragment Assignment on Assignment {
    __typename
    assignedBy
    completed
    completedDate
    dueDate
  }
`;
